<template>
  <div class="scheduling-location">
    <div class="_inner">
      <div style="padding-bottom: 10px;">
        <b class="ml-2 text-medium">配置地址</b>
      </div>
      <div class="scheduling-location-address">
        <div v-for="(item,index) in addresses" :key="index" 
          class="scheduling-location-address__item"
          :class="{ 'is-selected': selectIndex === index }"
        >
          <div class="action-buttons">
            <el-button type="success" plain size="mini" @click="onTargetAddress(index)" style="height:100%" >定位</el-button>
            <el-button type="danger" plain size="mini" @click="onRemoveAddress(index)" style="height:100%">移除</el-button>
          </div>
          <div class="address-info">
            <p class="info-row"><span>已选地址：</span> {{item.address}}</p>
            <p class="info-row sub-info"><span>经纬度：</span> {{item.lng}}, {{item.lat}} <span style="margin-left: 100px;">范围：</span> {{getOffsetLevelStr(item.gpsoffsetlevel)}}</p>
          </div>
        </div>
      </div>

      <div class="flex">
        <div style="width:500px">
          <el-button class="ml-2 mt-1" @click="onClickAddAddress" type="primary" plain>+ 继续添加地址</el-button>
          <el-button class="ml-2 mt-1" @click="onClickAddDefaultAddress" plain v-if="isAdmin || isjdx">添加默认会场</el-button>
        </div>
        <div class="border-left-grey" style="padding-left: 20px;">
          <quicklocation @onChoose="onChooseQuickLocation"></quicklocation>
        </div>
      </div>
    </div>

    <div class="scheduling-location-map">
      <LocationSelectorTian
        ref="LocationSelectorBaiduRef"
        @onAddressChanged="onAddressChanged"
      ></LocationSelectorTian>
    </div>
    <div
        class="form_box__group__item bg-grey "
        style="margin-top: 15px; margin-bottom: 15px ;padding:10px 0px;"
      >
        <div class="form_box__group__item__title">误差等级:</div>
        <div class="form_box__group__item__content ml-10">
          <el-radio-group v-model="gpsoffsetlevel" @change="onGPSLevelChanged">
            <el-radio :label="0">普通(1.5公里)</el-radio>
            <el-radio :label="1">小(0.5公里)</el-radio>
            <el-radio :label="2">大(3公里)</el-radio>
            <el-radio :label="3">超大(6公里)</el-radio>
          </el-radio-group>
        </div>
      </div>
  </div>
</template>

<script>
// import LocationSelectorBaidu  from "@/views/module/start/comp/components/LocationSelectorBaidu";
import LocationSelectorQQ  from "@/views/module/start/comp/components/LocationSelectorQQ";
import LocationSelectorTian  from "@/views/module/start/comp/components/LocationSelectorTian";
import {getSchedulingAdddresss} from "@/api/module/scheduling/scheduling"
import quicklocation from "@/views/components/quicklocation.vue";

export default {
  name: "schedulinglocation",
  components: {
    LocationSelectorTian,
    quicklocation
  },
  data() {
    return {
      
      // addresses:[
      //   {
      //     address: "aaaaaaaaaaaaaaaaaaa",
      //     lat: 1.1,
      //     lng: 222.22,
      //     gpsoffsetlevel : 1
      //   }
      // ],
      isAdmin : false,
      isjdx : 0,

      selectIndex : -1,
      
      addresses : [],

      gpsoffsetlevel : 0, //0 普通、1 小 、 2 大 、3 超大
      address: "",
      lat: null,
      lng: null,
    };
  },
  methods:{
    init(){
      this.addresses = new Array();

      this.initComponent();
    },
    initComponent(){
      this.$refs.LocationSelectorBaiduRef.init();
    },
    getOffsetLevelStr(item){
      if(item == 0){
        return "普通"
      }
      if(item == 1){
        return "小"
      }
      if(item == 2){
        return "大"
      }
      if(item == 3){
        return "超大"
      }
      return "无"
    },
    onAddressChanged(address,index){
      if(index >= 0){
        this.addresses[index].location = address.location;
        this.addresses[index].lat = address.lat;
        this.addresses[index].lng = address.lng;
      }
      else {
        this.address = address.location;
        this.lat = address.lat;
        this.lng = address.lng;
      }


      this.emitData();
    },

    setAddresses(addresses){
      console.log("setAddresses",addresses)
      this.addresses = addresses;
    },

    onRemoveAddress(index){

      this.addresses.splice(index,1)

      this.emitData();
      console.log("onRemoveAddress",index,this.addresses)

    },
    
    // 定位
    onTargetAddress(index){
      var address = this.addresses[index];
      console.log("onTargetAddress",index,address)

      this.$refs.LocationSelectorBaiduRef.initLocation(address.lng,address.lat,index,address.address)
      this.gpsoffsetlevel = address.gpsoffsetlevel

      this.selectIndex = index;
    },
    // 增加地址
    onClickAddAddress(){

        if(this.selectIndex >= 0){
           this.selectIndex = -1;
            // 初始化数据
            this.gpsoffsetlevel = 0;
            this.$refs.LocationSelectorBaiduRef.init();
        }

        else {
            if(!this.address){
              this.$message.error("未填写地址");
              return;
            }

            if(!this.lng && !this.lat){
              this.$message.error("未获取经纬度信息，请尝试移动标尺");
              return;
            }

            if(this.gpsoffsetlevel == null){
              this.gpsoffsetlevel = 0;
            }

            let data =  {
              address: this.address,
              lat: this.lat,
              lng: this.lng,
              gpsoffsetlevel : this.gpsoffsetlevel
            }

            this.addresses.push(data);

            // 初始化数据
            this.gpsoffsetlevel = 0;
            this.$refs.LocationSelectorBaiduRef.init();
        }


        this.emitData();
    },

    onClickAddDefaultAddress(){
      
      let adds = getSchedulingAdddresss();


      this.addresses = new Array();

      for(let i = 0; i < adds.length; i++){
        this.addresses.push(adds[i])
      }

      this.emitData();



      // addresses:[
      //   {
      //     address: "aaaaaaaaaaaaaaaaaaa",
      //     lat: 1.1,
      //     lng: 222.22,
      //     gpsoffsetlevel : 1
      //   }
      // ],
      // isAdmin : false,
      
      // addresses : [],
    },

    // emit 
    emitData(){

      let datas = new Array();

      if(this.hasAddressData){

        let data =  {
          address: this.address,
          lat: this.lat,
          lng: this.lng,
          gpsoffsetlevel : this.gpsoffsetlevel
        }

        datas.push(data);
      }

      for(let i = 0 ; i < this.addresses.length; i++){
        datas.push(this.addresses[i]);
      }

      this.$emit("onDataChanged",datas)
    },

    onGPSLevelChanged(){
      console.log("onGPSLevelChanged",this.gpsoffsetlevel)
      if(this.selectIndex >= 0){
        this.addresses[this.selectIndex].gpsoffsetlevel = this.gpsoffsetlevel
      }
    },

    onChooseQuickLocation(data){
      this.gpsoffsetlevel = data.gpsoffsetlevel
      this.$refs.LocationSelectorBaiduRef.initLocation(data.lng,data.lat,this.selectIndex,data.address)
    }
  },

  computed:{
    hasAddressData(){
      if(!this.address){
          return false;
      }

      if(!this.lat && !this.lng){
        return false;
      }

      return true;
    }
  },

  watch:{
    gpsoffsetlevel(){
      this.emitData();
    }
  },

  created() {
    this.isAdmin = this.$store.getters['profileModule/isadmin'];
    this.isjdx = this.$store.getters['profileModule/isjdx'];
  },
};
</script>

<style lang="scss" scoped>

.scheduling-location-address{
    max-height: 400px; // Limit height if many items
    overflow-y: auto;  // Scroll if needed
    margin-bottom: 10px;
}



.scheduling-location-address__item {
    display: flex;
    flex-direction: row;
    align-items: flex-start; // Align to top so buttons don't stretch
    padding: 8px 10px;
    margin-bottom: 5px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    transition: all 0.2s;
    height: 50px;

    &.is-selected {
      // border-color: #409eff;
      background-color: #ecf5ff;
      box-shadow: 0 0 5px rgba(64, 158, 255, 0.2);
      
      .action-buttons el-button {
        // Optional: make buttons more prominent if needed
      }
    }

    &:hover {
      border-color: #c0c4cc;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .action-buttons {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // flex-direction: column;
      gap: 5px;
      margin-right: 15px;
      min-width: 60px; // Ensure consistent width for buttons
    }

    .address-info {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }




    p {
      margin: 0;
      line-height: 1.4; // Tighter line height
      font-size: 14px;
      color: #606266;

      &.info-row {
        margin-bottom: 2px;
      }

      &.sub-info {
        font-size: 13px;
        color: #909399;
      }

      span {
        font-weight: bold;
        color: #303133; // Darker label color
        margin-right: 5px;
      }
    }
}

/* .scheduling-location-address{
  background-color: antiquewhite;
} */

.scheduling-location{
  ._inner{
      // padding: 20px 0;
      padding: 10px;
      margin-bottom: 10px;
      background-color: rgb(250, 250, 250);
  }

}



</style>
